import React from 'react';

const SvgKw = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="KW_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="KW_svg__b" fill="#fff">
        <use xlinkHref="#KW_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#D72238" mask="url(#KW_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#169A53" mask="url(#KW_svg__b)" d="M0 0h28v6.667H0z" />
      <path
        fill="#262626"
        mask="url(#KW_svg__b)"
        d="M0 0l9.333 6.667v6.666L0 20z"
      />
    </g>
  </svg>
);

export default SvgKw;
